export enum PromptType {
  BZ_OBJECT_CHANGE_POSITIONS_COST_CENTER = 'BZ_OBJECT_CHANGE_POSITIONS_COST_CENTER',
  BZ_OBJECT_CHANGE_PRICE_GROUP_CHANGE_PRICE = 'BZ_OBJECT_CHANGE_PRICE_GROUP_CHANGE_PRICE',
}
